import React from 'react';
import { SunriseIcon } from 'lucide-react';
export function CTASection() {
  return <section className="py-20 bg-gradient-to-b from-purple-50 to-purple-100" data-id="element-62">
      <div className="container mx-auto px-4" data-id="element-63">
        <div className="max-w-3xl mx-auto text-center" data-id="element-64">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-purple-800" data-id="element-65">
            Tu Próximo Paso
          </h2>
          <div className="bg-white p-8 md:p-10 rounded-2xl shadow-xl mb-10" data-id="element-66">
            <p className="text-lg text-gray-700 mb-6" data-id="element-67">
              Imagina abrir los ojos mañana con una calma que no sentías hace
              años… Con la certeza de que todo, absolutamente todo, está bien.
            </p>
            <p className="text-lg font-medium text-purple-800 mb-6" data-id="element-68">
              Ese futuro comienza con una decisión hoy.
            </p>
            <a href="#pricing" className="bg-purple-600 hover:bg-purple-700 text-white px-8 py-4 rounded-full text-lg font-medium shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 flex items-center mx-auto inline-flex" data-id="element-69">
              <SunriseIcon size={20} className="mr-2" data-id="element-70" />
              Comenzar Mi Reto de 30 Días
            </a>
          </div>
          <p className="text-xl font-medium text-purple-800 italic" data-id="element-71">
            El cielo está dentro de ti. Solo necesitas entrar.
          </p>
        </div>
      </div>
    </section>;
}